<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    const accounts = await this.getAccounts()
    if (accounts.length === 0) {
      const path = '/auth/accounts/sales'
      if (this.$route?.meta?.requireSignin !== false) {
        if (this.$route.path !== path && this.routerStatusRedirect) {
          this.$router.replace(path)
        }
        return
      }
    }
    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
  methods: {
    ...mapActions('account', ['getAccounts']),
  },
}
</script>

<style></style>
